import { waitForElementInViewOnce } from '@helpers/functions';

class ContentTileItem {
  item: HTMLElement;
  insideCarousel: boolean;

  constructor(item: HTMLElement, insideCarousel: boolean) {
    this.item = item;
    this.insideCarousel = insideCarousel;

    this.handleItemVisible();
  }

  handleItemVisible() {
    if (this.insideCarousel) return;

    waitForElementInViewOnce(this.item)
      .then((entry) => {
        if (entry.isIntersecting && !entry.target.classList.contains('show')) {
          entry.target.classList.add('show');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}

export { ContentTileItem };
